export default "__VITE_ASSET__Cr3ns_KX__"